import { request } from '@stacks/connect';
import { useAtom } from 'jotai';

import { ledgerDialogAtom } from '../store';
import { SAFE_TX_SUCCESS, SafeTxError, safeTxError, SafeTxResponse } from '../types';

import { PROVIDERS } from './useData';
import { useWalletProvider } from './useWalletProvider';

const useSign = () => {
  const walletProvider = useWalletProvider();
  const [, setLedgerDialog] = useAtom(ledgerDialogAtom);

  const signTx = async (
    txHex: string,
    afterSign: (signedTx: string) => Promise<SafeTxResponse>
  ): Promise<SafeTxResponse> => {
    if (!walletProvider) return Promise.reject(safeTxError(SafeTxError.UnspecifiedError));

    if (walletProvider.provider === PROVIDERS.Ledger) {
      setLedgerDialog({ isSignTxOpened: true, unsignedTx: txHex, onSignSuccess: afterSign });

      return SAFE_TX_SUCCESS;
    }

    return new Promise(async (resolve, reject) => {
      request({ provider: walletProvider.stacksProvider }, 'stx_signTransaction', {
        transaction: txHex,
      })
        .then(async (res: any) => {
          const signedTx = res.transaction;
          const successful = await afterSign(signedTx);
          resolve(successful);
        })
        .catch((e) => {
          console.error(e);
          reject(safeTxError(SafeTxError.UnspecifiedError));
        });
    });
  };

  return {
    signTx,
  };
};

export default useSign;
